import { NodeViewRendererProps } from '@tiptap/core';
import { usePlaceholderValue } from '../../../../Service/hooks/usePlaceholderValue';
import { ValidationS } from '../../../../Service/ValidationS';

interface NodeAttributes {
  id: string;
  label?: string;
}

const EventAmountPlaceholder = ({ node }: NodeViewRendererProps) => {
  const { id, label } = node.attrs as NodeAttributes;
  const placeholderValue = usePlaceholderValue(id);
  const isValuePresent = ValidationS.isValuePresent(placeholderValue);
  const fallbackLabel = label ?? id;
  const unresolvedValue = id.includes(':') ? fallbackLabel.replace(/_/g, ' ') : fallbackLabel;
  const finalValue = isValuePresent ? String(placeholderValue) : unresolvedValue;

  return (
    <span data-node-view-wrapper="" className={isValuePresent ? 'mention' : 'unresolved'}>
      {finalValue}
    </span>
  );
};

export default EventAmountPlaceholder;
